import { helpers } from 'vuelidate/lib/validators'
import IBAN from 'iban'

export const numericWithSpaces = helpers.regex('numericWithSpaces', /^(?=.*\d)[\d ]+$/)

export const phoneNumber = helpers.regex(
  'phoneNumber',
  /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/,
)

export const validateBankClearingNr = helpers.regex('validateBankClearingNr', /^(?:\d{3,5})?$/)

export const zipCode = helpers.regex('zipCode', /^\d{5}$|^\d{5}-\d{4}$/)

export const decimal = helpers.regex('decimal', /^(?:\d+|\d{1,3}(?:,\d{3})+)(?:(\.|,)\d+)?$/)

export const website = helpers.regex(
  'website',
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]+(-?[a-zA-Z0-9])*\.)+[\w]{2,}(\/\S*)?$/,
)

export const validateIban = helpers.withParams({ type: 'validateIban' }, value =>
  IBAN.isValid(value),
)

export const notZero = helpers.regex('notZero', /[^0]+$/)
